import { Controller, useFormContext } from "react-hook-form";
import { SwitchUserFormValues } from "../../types";
import { View } from "react-native-ui-lib";
import { Stack, Text } from "@towersystems/roam-common-native";
import { useSwitchUserFormAdditionalActions } from "../../hooks";
import { OTPInput } from "../../../OTPInput";

export interface EnterMfaCodeFieldsetProps {}

export const EnterMfaCodeFieldset = ({}: EnterMfaCodeFieldsetProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SwitchUserFormValues>();

  const maybeContext = useSwitchUserFormAdditionalActions();

  return (
    <Stack vertical>
      <View>
        <Text fontWeight="bold" variant="heading3">
          Enter MFA Code
        </Text>
        <Text>
          Please enter the code you received from your chosen MFA method.
        </Text>
      </View>
      <View style={{ maxWidth: 300, width: "100%" }}>
        <Controller
          control={control}
          name="mfaCode"
          render={({ field: { onChange, value } }) => {
            let normalizedValue = value ? value : "";
            return (
              <OTPInput
                value={normalizedValue.split("")}
                onChange={(v) => {
                  onChange(v.join(""));
                }}
                length={6}
              />
            );
          }}
        />
      </View>
      {errors.mfaCode && (
        <Text color="destructive">{errors.mfaCode.message}</Text>
      )}
    </Stack>
  );
};
